import { Injectable } from '@angular/core';
import { MwHttpService } from '@core/http';
import { Observable } from 'rxjs';
import { OrderApiModel } from 'app/models/order-api.model';
import { MwLoadOptions } from 'app/models/load-options.model';
import { MwLoadOptionsService } from './utils/load-options.service';
import { MwPayloadModel } from 'app/models/payload.model';
import { first, map } from 'rxjs/operators';

@Injectable()
export class MwOrdersApiService {
  constructor(
    private http: MwHttpService,
    private loadOptionsService: MwLoadOptionsService
  ) {}

  private crudEndpoint = '/integration/v2/Companies/{companyId}/Orders';
  private queryForAssigningEndpoint =
    '/integration/v5/Companies/{companyId}/Orders';

  getOrders(
    loadOptions?: MwLoadOptions
  ): Observable<MwPayloadModel<OrderApiModel[]>> {
    let params = loadOptions
      ? this.loadOptionsService.buildQuery(loadOptions)
      : '';

    if (params) {
      params = '?' + params;
    }

    const endpoint = this.queryForAssigningEndpoint;

    return this.http.authGet<MwPayloadModel<OrderApiModel[]>>(
      `${endpoint}${params}`
    );
  }

  getOrder(orderId: number): Observable<OrderApiModel> {
    const request = new MwLoadOptions({
      take: 1,
      filter: [['orderId', '=', orderId]],
      hasCount: true,
      numericParameters: {
        orderId: true,
      },
    });

    return this.getOrders(request).pipe(
      first(),
      map((i: MwPayloadModel<OrderApiModel[]>) => i?.results?.[0])
    );
  }

  createOrder(order: OrderApiModel): Observable<OrderApiModel> {
    return this.http.authPost<OrderApiModel>(this.crudEndpoint, {
      body: order,
    });
  }

  editOrder(order: OrderApiModel): Observable<OrderApiModel> {
    return this.http.authPut<OrderApiModel>(this.crudEndpoint, {
      body: order,
    });
  }

  deleteOrder(order: OrderApiModel): Observable<any> {
    return this.http.authDelete<OrderApiModel>(this.crudEndpoint, {
      body: order,
    });
  }
}
